export default "__VITE_ASSET__BOH_WXvB__"